/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { PhotoGridProps } from "../../service/interfaces/Components";

const PhotoGrid: React.FC<PhotoGridProps> = ({ images }) => {
  const maxDisplay = 3;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openModal = (index: number) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const goToNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrevious = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const selectImage = (index: number) => {
    setCurrentImageIndex(index);
  };

  return (
    <>
      {/* Image Grid */}
      <div className="flex space-x-2 cursor-pointer">
        {images.slice(0, maxDisplay).map((image, index) => (
          <div
            key={index}
            className="relative w-[30px] h-[30px] rounded-md overflow-hidden"
            onClick={() => openModal(index)}
          >
            <img
              src={image}
              alt={`Image ${index + 1}`}
              className="w-full h-full object-cover"
            />
            {index === maxDisplay - 1 && images.length > maxDisplay && (
              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-[14px] font-bold">
                +{images.length - maxDisplay}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          {/* Close Button */}
          <button
            className="absolute top-4 right-4 text-white text-2xl font-bold"
            onClick={closeModal}
          >
            ✕
          </button>

          {/* Modal Content */}
          <div className="relative w-[600px] max-h-[80vh] bg-white rounded-md shadow-lg flex flex-col">
            {/* Main Image Container */}
            <div className="relative flex-1 w-full h-[400px] flex items-center justify-center p-4">
              {/* Navigation Buttons */}
              <button
                onClick={goToPrevious}
                className="absolute left-4 text-black text-2xl font-bold z-10 bg-white bg-opacity-50 rounded-full w-8 h-8 flex items-center justify-center"
              >
                ‹
              </button>

              {/* Image */}
              <img
                src={images[currentImageIndex]}
                alt={`Image ${currentImageIndex + 1}`}
                className="max-w-full max-h-full object-contain"
              />

              <button
                onClick={goToNext}
                className="absolute right-4 text-black text-2xl font-bold z-10 bg-white bg-opacity-50 rounded-full w-8 h-8 flex items-center justify-center"
              >
                ›
              </button>
            </div>

            {/* Image Previews/Filmstrip */}
            <div className="w-full bg-gray-100 p-4 overflow-x-auto">
              <div className="flex space-x-4 justify-center">
                {images.map((image, index) => (
                  <div
                    key={index}
                    className={`relative w-16 h-16 rounded cursor-pointer transition-all duration-200 ${
                      currentImageIndex === index
                        ? "ring-2 ring-green-500 ring-offset-2"
                        : "border border-gray-300 opacity-70 hover:opacity-100"
                    }`}
                    onClick={() => selectImage(index)}
                  >
                    <img
                      src={image}
                      alt={`Thumbnail ${index + 1}`}
                      className="w-full h-full object-cover rounded"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PhotoGrid;